import { render, staticRenderFns } from "./SchoolEstablishmentForm.vue?vue&type=template&id=44e4476c&scoped=true"
import script from "./SchoolEstablishmentForm.vue?vue&type=script&lang=js"
export * from "./SchoolEstablishmentForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolEstablishmentForm.vue?vue&type=style&index=0&id=44e4476c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4476c",
  null
  
)

export default component.exports